import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'

import AppRoutes from '@/routes/AppRoutes'

import { loadingOverlaySelector } from '@/stores/ui/loadingOverlaySlice'
import storage from '@/utils/storage'
import { authSelector, initAuth, loadMe } from './stores/auth/authSlice'
import { Box } from '@chakra-ui/react'
import { LoadingOverlay, LoadingSection } from './components/Elements'

const App = () => {
  const dispatch = useDispatch()

  const { appLoaded, isAuthenticated } = useSelector(authSelector)
  const { show: showLoadingOverlay, text: loadingText } = useSelector(loadingOverlaySelector)
  const [searchParams] = useSearchParams()

  const token = searchParams.get('token')
  const loginCode = searchParams.get('code')

  useEffect(() => {
    if (token && token !== '') {
      storage.setToken(token)

      console.log('token', token)

      dispatch(loadMe())
    }
  }, [dispatch, token])

  useEffect(() => {
    //If Success, it means there is a valid token
    if (isAuthenticated || storage.getToken()) {
      dispatch(loadMe())
    } else {
      dispatch(initAuth())
    }
  }, [dispatch, isAuthenticated])

  useEffect(() => {
    if (loginCode) {
      try {
        dispatch(showLoadingOverlay())
        dispatch(loginWithSiemensID({ code: loginCode }))
      } catch (err) {
        //dispatch(hideLoadingOverlay())
      }
    }
  }, [loginCode])

  if (!appLoaded) {
    return <LoadingSection />
  }

  return (
    <Box>
      <LoadingOverlay isActive={showLoadingOverlay} text={loadingText} />
      <AppRoutes />
    </Box>
  )
}

export default App
